<div class="tag" [ngClass]="className" [matTooltip]="tooltipText">{{restockTag}}</div>